import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  currentLang: string;

  constructor(private translate: TranslateService) { 
    this.currentLang = this.translate.currentLang
  }

  ngOnInit() {
  }

}
